/* eslint-disable no-comments/disallowComments */
import { LogRecord, LogTimers, VehicleDto } from '@fleet-beat/api';
import { CompanyDto, UserDto } from '@fleet-beat/core';

export interface DriverDtoAdditional {
  coDriver?: DriverDto;
}

export interface DriverDto extends UserDto, DriverDtoAdditional {
  truckId?: string;
  hasCdl?: boolean;
  hasUsDot?: boolean;
  hasInDot?: boolean;
  hasMcDot?: boolean;
  // insuranceCertificate?: string;
  // unifiedCarrierRegistration?: string;
  // iftaLicense?: string;
  // eldDotReferenceCard?: string;
  // salesTaxExemptionCertificate?: string;
  licenseIssuingState?: string;
  licenseNumber?: string;
  eventLogsFrom?: string;
  company?: CompanyDto;
  truck?: VehicleDto;
  password?: string;
  homeTerminalAddress?: string;
  address1?: string;
  address2?: string;
  description?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  status?: LogRecord;
  sessions?: DriverSession[];
  timers?: LogTimers;
  allowPersonalConveyance?: boolean;
  allowYardMove?: boolean;
}

export interface DriverSession {
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  id: string;
  actorType: 'driver';
  actorId: string;
  deviceParams: {
    device: string;
    osName: 'android' | 'ios';
    appBuild: number;
    osVersion: number;
    appVersion: number;
  };
}

export interface EventLogCoDriverPeriod {
  driverId: string;
  coDriverId: string;
  startedAt: Date;
  endedAt: Date | null;
  coDriver?: DriverDto;
  driver?: DriverDto;
}
